import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    idbranchoffice:number,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const SellerBranchesModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, storeSelected, liststore, clearState } = props;

    const { action, createStore, editStore } = useStoreStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: storeSelected ? storeSelected.id :'',
        code: storeSelected ? storeSelected.code :'',
        name: storeSelected ? storeSelected.name :'',
        description: storeSelected ? storeSelected.description :'',
        idbranchoffice: storeSelected ? storeSelected.idbranchoffice :'',
        status: storeSelected ? storeSelected.status :'1',
    });

    useEffect(() => {
        getBranchOfficeApi()
    },[])

    useEffect(() => {
        if(storeSelected && branchOffices){
            setCustomBranchOffice(storeSelected.idbranchoffice, branchOffices)
        }
    },[storeSelected, branchOffices])

    const setCustomBranchOffice = (idbranchoffice, branchOffices) => {
        const data = branchOffices.find(branch => branch.id == idbranchoffice);
        return setBranchOfficeSelected(data);
    }

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.idbranchoffice) errors.idbranchoffice = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(storeSelected){
            const response:any = await editStore(storeSelected.id, values);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(values);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar bodega' : (action == 'add' ? 'Nueva bodega' : 'Detalle de la bodega')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Sucursal:</FormLabel>
                                            <Autocomplete
                                                id="idbranchoffice"
                                                size="small"
                                                value={!!branchOfficeSelected ? branchOfficeSelected : null}
                                                options={branchOffices || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idbranchoffice && touched.idbranchoffice ? true : false}
                                                        helperText={errors.idbranchoffice && touched.idbranchoffice ? errors.idbranchoffice : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setBranchOfficeSelected(newValue)
                                                    setFieldValue('idbranchoffice', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Estado:</FormLabel>
                                            <Select
                                                id="status"
                                                value={values.status}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("status", event.target.value);
                                                }}
                                                error={ errors.status && touched.status ? true : false }
                                                fullWidth
                                                inputProps={{ readOnly: action == 'detail' }}
                                            >
                                                {
                                                    states.map((state, i) => {
                                                        return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}